module.exports = __webpack_public_path__ + "static/img/card2.448bb714.png";